import React, { useState, useEffect } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    TextField, Button, IconButton, MenuItem, Grid,
    Box
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const roles = ['Super Admin', 'Admin', 'User'];
const statusOptions = ['Enable', 'Disable'];

const UpdateUserDialog = ({ open, onClose, user, onUpdate, onDelete }) => {
    
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('');
    const [status, setStatus] = useState('');
    
    // Read-only fields
    const [userId, setUserId] = useState('');
    const [createdAt, setCreatedAt] = useState('');
    const [updatedAt, setUpdatedAt] = useState('');

    useEffect(() => {
        if (user) {
            setEmail(user.email || '');
            setRole(user.role || '');
            setStatus(user.enabled === true ? 'Enable' : 'Disable'  || '');
            setUserId(user.username || '');
            setCreatedAt(user.createdAt || '');
            setUpdatedAt(user.updatedAt || '');
        }
    }, [user]);

    const isFormValid = email.trim() !== '' && role.trim() !== '' && status.trim() !== '';

    const handleUpdate = () => {
        const updatedUser = { userId, email, role, status };
        onUpdate(updatedUser);
        onClose();
    };

    const handleDelete = () => {
        const deletedUser = { userId, email, role, status};
        onDelete(deletedUser);
        onClose();
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>
                Update User
                <IconButton
                    aria-label="delete"
                    onClick={handleDelete}
                    sx={{ float: 'right', color: 'error.main' }}
                >
                    <DeleteIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                <Box display="flex" flexDirection="column" gap={2}>
                    <TextField
                        label="User ID"
                        value={userId}
                        fullWidth
                        disabled
                        InputProps={{ readOnly: true }}
                    />
                    <TextField
                        label="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        fullWidth
                        disabled
                        required
                        InputProps={{ readOnly: true }}
                    />
                    <TextField
                        label="Role"
                        select
                        value={role}
                        onChange={(e) => setRole(e.target.value)}
                        fullWidth
                        required
                    >
                        {roles.map((r) => (
                            <MenuItem key={r} value={r}>{r}</MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        label="Status"
                        select
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        fullWidth
                        required
                    >
                        {statusOptions.map((s) => (
                            <MenuItem key={s} value={s}>{s}</MenuItem>
                        ))}
                    </TextField>
                    <TextField
                        label="Created At"
                        value={createdAt}
                        fullWidth
                        disabled
                        InputProps={{ readOnly: true }}
                    />
                    <TextField
                        label="Updated At"
                        value={updatedAt}
                        fullWidth
                        disabled
                        InputProps={{ readOnly: true }}
                    />
                </Box>
            </DialogContent>

            <DialogActions>
                <Button 
                onClick={handleClose}
                sx={{ height: 35, backgroundColor: 'grey', color: 'white', fontSize: 13,}}
                >
                    Cancel
                </Button>
                <Button 
                onClick={handleUpdate} 
                disabled={!isFormValid} 
                variant="contained"
                sx={{ height: 35, color: 'black', fontSize: 13,}}
                >
                    Update
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UpdateUserDialog;
